import { useTranslation } from "react-i18next";
import { Page, Group, Grid, Layout, Button } from "@/comn/components"; // 화면 구성 컴포넌트
import { useGrid, TGridSchema, useModal } from "@/comn/hooks"; // hook
import { comnUtils } from "../utils";
import { useState } from "react";

export type ExcelUploadProps = {
    templateId?: string;
    title?: string;
    url: string | any;
    data?: any;
    callback?: Function;
    msgList?: Function;
};
export const SG_EXCEL_UPLOAD_LIST: TGridSchema = {
    id: "errors",
    options: { pagination: "in", index: true },
    head: [
        { cells: [{ header: "L_ITM_NM", binding: "valdnItmNm", width: 200 }] },
        { cells: [{ header: "L_ITM_VAL_2", binding: "valdnItmVal", width: 200 }] },
        { cells: [{ header: "L_MSG", binding: "msgCn", width: "*" }] },
    ],
    body: [
        {
            cells: [{ binding: "valdnItmNm" }],
        },
        {
            cells: [{ binding: "valdnItmVal" }],
        },
        {
            cells: [{ binding: "msgCn", align: "left" }],
        },
    ],
};

export const CommonExcelUpload = (props: ExcelUploadProps) => {
    const { t } = useTranslation();
    const modal = useModal();
    const { templateId, title, url, data, callback, msgList } = props;
    const grid = {
        excelUploadResult: useGrid({ defaultSchema: SG_EXCEL_UPLOAD_LIST, size: 100 }),
    };
    const [errors, setErrors] = useState<Array<any>>([]);

    return (
        <Page title={title ? t(title) : t("L_EXC_UPLD")} info={true} pgeUid="">
            <Group>
                <Group.Body>
                    <Group.Section>
                        <Layout>
                            <Layout.Left>
                                <Button
                                    role="tmplDown"
                                    onClick={() => {
                                        // template download
                                        comnUtils.downloadTemplate(templateId);
                                    }}
                                ></Button>
                                <Button
                                    role="excelUpload"
                                    onClick={async () => {
                                        const result: any = await comnUtils.importExcel({ url: url, data: data || {} });

                                        if (result.status === 200 || result.status === 201) {
                                            let _errors = [];

                                            if (msgList) {
                                                _errors = msgList(result);
                                            }

                                            if (_errors === undefined || _errors.length <= 0) {
                                                modal.openModal({
                                                    content: t("msg.00003"),
                                                    onClose: () => {
                                                        if (callback) callback(result.data);
                                                    },
                                                });
                                            } else {
                                                setErrors(_errors);
                                            }
                                        } else {
                                            modal.openModal({
                                                content: t("msg.com.00026"),
                                            });
                                        }
                                    }}
                                ></Button>
                            </Layout.Left>
                            <Layout.Right>
                                <Button
                                    role="excelDown"
                                    onClick={() => {
                                        let time = String(comnUtils.getDate());
                                        grid.excelUploadResult.exportExcel({
                                            excelName: `ErrorList(${time})`,
                                            sheetName: "Error List",
                                        });
                                    }}
                                ></Button>
                            </Layout.Right>
                        </Layout>
                    </Group.Section>
                    <Group.Title title=""></Group.Title>
                    <Group.Section>
                        <Grid {...grid.excelUploadResult.grid} data={comnUtils.getGridData(errors)} />
                    </Group.Section>
                </Group.Body>
            </Group>
        </Page>
    );
};
